// Link de "Minhas assinaturas" (dashboard do Checkout, `/minhas-assinaturas/:hash`), gerado uma vez por
// sessão pelo store `subscription` a partir do e-mail do aluno logado. Usado pelo mixin `subscriptionUrl`
// (menu "Gerenciar Assinaturas" e modal de acesso suspenso) e pelo toque no push de assinatura em atraso
// (pushRouter, STORY-1642 / sc-1616).
//
// Devolve a URL, ou `null` quando não deu — sem conexão, sem assinatura (204) ou erro —, já com o aviso no toast.
export function ensureSubscriptionUrl (store) {
  const cached = store.state.subscription.subscriptionUrl;
  if (cached) return Promise.resolve(cached);

  // Sem rede o link não sai, e o toast de erro abaixo é suprimido offline: sem
  // este aviso, o toque no push de assinatura em atraso não faria nada visível.
  if (store.state.dom && store.state.dom.isConnected === false) {
    store.commit('toast/NEW', {
      type: 'info',
      message: 'Sem conexão. Conecte-se à internet para abrir suas assinaturas.'
    });
    return Promise.resolve(null);
  }

  return store.dispatch('subscription/generateSubscriptionUrl').then((response) => {
    const url = store.state.subscription.subscriptionUrl;
    if (url) return url;

    const noSubscription = response && response.status === 204;
    store.commit('toast/NEW', {
      type: noSubscription ? 'info' : 'error',
      message: noSubscription
        ? 'Nenhuma assinatura ativa encontrada para o seu perfil.'
        : 'Não foi possível abrir a página de assinaturas. Tente novamente mais tarde.',
      suppressOffline: true
    });
    return null;
  });
}
